import React, { useState } from 'react'
import { number } from 'yup'
import { FlexRow, FlexColumn, Icon, Tooltip, TextInput, Text } from 'elements'
import { toTitleCase } from '../../../../utils/string'

const parsers = {
  integer: parseInt,
  float: parseFloat,
}

const replaceRx = {
  integer: /[^0-9]/g,
  float: /[^0-9.]/g,
}

const thresholdInfo = {
  amount: 'Only include transactions greater than or equal to a certain amount.',
  amountVariance: 'Highlight variance above a certain amount.',
  percentVariance: 'Highlight variance above a certain percentage.',
  daysElapsed:
    'Minimum number of days elapsed between the transaction date and end of the report period.',
}

const numberTypes = {
  amount: 'float',
  amountVariance: 'float',
  percentVariance: 'integer',
  daysElapsed: 'integer',
}

const titles = {
  amountVariance: 'Amount Variance ($)',
  percentVariance: 'Percent Variance (%)',
}

export default function NumericThreshold({
  thresholdName,
  configSection,
  value,
  onChange,
  onValidate,
}) {
  const [validValue, setValidValue] = useState(true)

  const title = titles[thresholdName] || toTitleCase(thresholdName)
  const tooltipInfo = thresholdInfo[thresholdName]
  const numberType = numberTypes[thresholdName]

  return (
    <FlexColumn>
      <FlexRow
        alignItems="center"
        mb={validValue ? 'large' : 'xsmall'}
        justifyContent="space-between"
      >
        <FlexRow alignItems="center" flex="1">
          <Text fontWeight="bold" mr="xsmall">
            {title}
          </Text>
          <Icon
            name="question-circle"
            data-tip
            data-for={`${configSection.name}-${thresholdName}`}
            color="neutral.1"
            size="xsmall"
          />
        </FlexRow>
        <Tooltip id={`${configSection.name}-${thresholdName}`}>
          <FlexColumn>
            <Text>{tooltipInfo}</Text>
          </FlexColumn>
        </Tooltip>
        <FlexColumn flex="1">
          <TextInput
            onBlur={async () => {
              if (!value?.length) {
                onChange(null)
                return
              }

              try {
                await number().positive().validate(value)

                onChange(parsers[numberType](value))
              } catch {
                setValidValue(false)
                onValidate(false)
              }
            }}
            value={value}
            onChange={(event) => {
              setValidValue(true)
              onValidate(true)

              onChange(event.target.value.replace(replaceRx[numberType], ''))
            }}
            placeholder={toTitleCase(thresholdName)}
            borderColor={!validValue ? 'danger.0' : null}
          />
        </FlexColumn>
      </FlexRow>
      {!validValue ? (
        <Text color="danger.0" mb="large" ml="auto">
          {title} must be positive number
        </Text>
      ) : null}
    </FlexColumn>
  )
}
